/*//////////////////////*/
/* Imports
/*/ /////////////////////*/
import { useEffect, useRef } from "react";
import Element from "../../Element/Element.component";
import { setSocketIframeShortCut } from "../../../utils/websockets.utils";




const VideoIframe = ({
  video,
  socketID,
  socket,
  isError,
  isLoaded
}) => {
  /*//////////////////////*/
  /* Variables
  /*/ /////////////////////*/
  const socketsReady = useRef(false);
 


  /*//////////////////////*/
  /* Effects
  /*/ /////////////////////*/
  useEffect(() => {
    if (socket && !socketsReady.current) {
    //   socket.on("videoRemote", imagesRemote);
        isLoaded();
        socketsReady.current = true;
    }
    return () => {
    //   if (socket) socket.off("videoRemote", imagesRemote);
      setSocketIframeShortCut(null, socketID)
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [socket]);


  /*//////////////////////*/
  /* Functions
  /*/ /////////////////////*/
  const sendShortCut = (page) => {
    setSocketIframeShortCut(page, socketID)
  }

  /*//////////////////////*/
  /* Return
  /*/ /////////////////////*/
  return (
    <div className="w-full max-w-sm mb-12">
      <p className = "w-full" style = {{textAlign : "center", paddingBottom : "20px"}}>Iframe sur le PC principal, utilisez l'écran tactile pour naviguer dans le programme.</p>
      <p className = "w-full" style = {{textAlign : "center", paddingBottom : "20px"}}>Vous pouvez également utiliser les raccourcis ci-dessous.</p>
      {(video && video.iframeShortcut.length !== 0) && <ul>
        {video.iframeShortcut.map(shortcut => 
          <li onClick = {() => sendShortCut(shortcut.iframeUrl)}><Element
              text={shortcut.shortcutText}
              link={``}
          /></li>
        
        )}
      </ul>}
    </div>
  );
};

export default VideoIframe;
